import React from "react";

import { loaders } from "../../assets/images/loading";

interface IProps {
  race: string;
}

const Loader = ({ race }: IProps) => (
  <div style={{
    position: "fixed",
    display: "flex",
    alignItems: "center",
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.4)",
    zIndex: 990
  }}>
    <img
      src={loaders[race]}
      alt={"loader"}
      style={{
        display: "flex",
        marginLeft: "auto",
        marginRight: "auto",
        zIndex: 999
      }}
    />
  </div>
)

export default Loader;
